<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Sorteren | Ja of nee" [steps]="questions().length" [progress]="progress()" />

  <rid-mechanic-content>
    <!-- question -->
    @for (input of [question()]; track input.id) {
      <div
        class="absolute grid w-full place-items-center"
        [animate.enter]="index() > 0 ? 'wait-500 anim-slide-from-right' : ''"
        animate.leave="anim-slide-to-left"
        (animationend)="index() > 0 && $event.animationName === 'slide-from-right' ? presentItems() : undefined"
      >
        <!-- title -->
        <rid-mechanic-title class="-translate-y-24" [title]="question().question" />
        <div
          class="flex gap-4"
          animate.enter="wait-250 anim-pop-in"
          ridSfx="BUBBLE_POP"
          (animationend)="index() === 0 && $event.animationName === 'pop-in' ? presentItems() : undefined"
        >
          @for (option of input.options; track $index) {
            <rid-option #options [option]="option" [index]="input.options.length > 1 ? $index + 1 : undefined" />
          }
        </div>
      </div>
    }

    <!-- buttons -->
    <div class="absolute bottom-8 flex justify-center gap-4">
      <rid-button
        class="w-2xs"
        animate.enter="wait-500 anim-slide-from-bottom"
        animate.leave="anim-slide-to-bottom"
        content="Nee"
        appearance="DANGER"
        [disabled]="isChecking() === 'YES'"
        (click)="!isChecking() ? check('NO') : undefined"
      />
      <rid-button
        class="w-2xs"
        animate.enter="wait-500 anim-slide-from-bottom"
        animate.leave="anim-slide-to-bottom"
        content="Ja"
        [disabled]="isChecking() === 'NO'"
        (click)="!isChecking() ? check('YES') : undefined"
      />
    </div>

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
